import md from 'markdown-it';

const sortBooks = (data: any) => {
  let newDataObject: any = {}
  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      if (key === 'novels') {
        newDataObject['Novels'] = data[key]
      }
      if (key === 'anthologies') {
        newDataObject['Anthologies'] = data[key]
      }
      if (key === 'short-stories') {
        newDataObject['eShorts'] = data[key]
      }
      if (key === 'novellas') {
        newDataObject['Novellas'] = data[key]
      }
    }
  }

  return newDataObject
}

export const RequiredBooks = ({ data, note }: any) => {

  const newData = sortBooks(data)

  return (
    <section className='mt-8 mb-8'>
      <h2 className='text-2xl text-heresy-primary' id='reading-order'>Required Books</h2>
      {Object.keys(newData).map((type: any) => (
        <div key={type}>
          <h3 className='prose prose-invert lg:prose-xl text-heresy-secondary'>{type + ' (in order of appearance)'}</h3>
          <ol className='list-decimal ml-12'>
            {newData[type].map((book: any) => (
              <li key={book[Object.keys(book)[0]]} className='prose prose-invert lg:prose-xl'>{book[Object.keys(book)[0]]}</li>
            ))}
          </ol>
        </div>
      )
      )}
      <div className='prose prose-invert lg:prose-xl pt-4' dangerouslySetInnerHTML={{ __html: md().render(note) }} />
    </section>);
}
